import { render, staticRenderFns } from "./AboutView.vue?vue&type=template&id=e550a5d0&scoped=true"
var script = {}
import style0 from "./AboutView.vue?vue&type=style&index=0&id=e550a5d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e550a5d0",
  null
  
)

export default component.exports